import { Logo } from "./Logo";

export const Footer = () => (
  <footer data-testid="site-footer" className="border-t border-white/10 bg-[#08090C]">
    <div className="mx-auto grid max-w-7xl gap-10 px-5 py-14 md:grid-cols-3 lg:px-12">
      <div className="space-y-4">
        <Logo />
        <p className="max-w-xs text-sm text-zinc-400">Live outdoor concerts all summer in the Fallsview district of Niagara Falls, Ontario, Canada.</p>
      </div>
      <div className="text-sm text-zinc-300">
        <p className="mb-3 font-mono text-xs uppercase tracking-[0.25em] text-zinc-400">Info</p>
        <ul className="space-y-2">
          <li><a data-testid="footer-accessibility-link" href="/#faq" className="hover:text-white">Accessibility</a></li>
          <li><a data-testid="footer-policies-link" href="/#faq" className="hover:text-white">Ticket & venue policies</a></li>
          <li><a data-testid="footer-visit-link" href="/#venue" className="hover:text-white">Getting here</a></li>
        </ul>
      </div>
      <div className="text-sm text-zinc-400">
        <p className="mb-3 font-mono text-xs uppercase tracking-[0.25em] text-zinc-400">Note</p>
        <p>Artists, dates, prices and venue shown are sample placeholders for demonstration and will be replaced with confirmed details.</p>
      </div>
    </div>
    <div className="border-t border-white/5 px-5 py-6 text-center font-mono text-xs text-zinc-400">© {new Date().getFullYear()} Fallsview Summer Concert Series</div>
  </footer>
);
